import Vue from 'vue'
import layNav from '@/components/layout/layNav'
import textarea from './over/textarea'
// 导航组件
Vue.component('app-nav', layNav)
Vue.component('el-textarea', textarea)
